import styled, { css } from "styled-components";
import {
  DEFAULT_PRICE_PUBLIC_LOCATION,
  NAME_ABOVE_PRODUCT_LAYOUT,
  NAME_BENEATH_PRODUCT_LAYOUT,
} from "../../../CanvasViewer/EncarteConstants";
import { getPriceFontSize, getPriceScale } from "./Price.utils";

const getMainPriceWidth = ({
  styles,
  length,
  canvasScale,
  commonMultiplier,
}) => {
  const safeLength = Math.max(Number(length) || 1, 1);
  const safeScale = Number(canvasScale) || 1;
  const safeMultiplier = Number(commonMultiplier) || 1;
  const fontSize = Number(styles?.fontSize) || 0;
  const widthMultiplier = 3 * safeMultiplier;

  return (
    ((fontSize * widthMultiplier) / 2 / Math.min(safeLength * 0.06, 6)) *
    safeScale
  );
};

export const Container = styled.div`
  height: 100%;
  width: 100%;
  ${({ className }) =>
    className &&
    (className.includes("prateleira-pequeno-price") ||
      className.includes("prateleira-medio-price") ||
      className.includes("prateleira-grande-price")) &&
    css`
      align-items: end;
    `}
`;

export const Measurement = styled.div`
  text-transform: uppercase;
  position: relative;
  text-align: right;
`;

export const BasePriceStyles = css`
  z-index: 3;
  line-height: 1;
  width: 100%;

  .number-wrapper {
    font-weight: 800;
    display: flex;
    align-items: center;
  }

  .price-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }

  .sign {
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    position: relative;
    background-color: transparent;
  }

  .decimal-unity-wrapper {
    display: flex;
    flex-direction: column;
    line-height: 1;
  }

  .decimal {
    letter-spacing: -1px;
    text-align: left;
  }

  ${({
    styles,
    canvasScale,
    position,
    intMultiplier,
    decMultipier,
    signMultiplier,
    length,
  }) => {
    const signTextColor = styles.priceTxtColor;
    const pricePosition = position ? position : "absolute";

    return css`
      font-size: ${getPriceFontSize(styles, canvasScale, intMultiplier)}px;
      color: ${styles.txtColor} !important;
      position: ${pricePosition};

      .price-wrapper {
        transform: scale(${getPriceScale(length)});
      }

      .price-wrapper {
        color: ${styles.priceTxtColor};
      }

      .decimal {
        font-size: ${getPriceFontSize(styles, canvasScale, decMultipier)}px;
      }

      .sign {
        font-size: ${getPriceFontSize(styles, canvasScale, signMultiplier)}px;
        color: ${signTextColor};
      }

      ${Measurement} {
        font-size: ${getPriceFontSize(styles, canvasScale, signMultiplier)}px;
      }
    `;
  }}
`;

export const PriceBackgroundStyles = css`
  ${({
    styles,
    length,
    imageUrl,
    canvasScale,
    heightMultiplier,
    widthMultiplier,
  }) => {
    return css`
      z-index: 2;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      width: ${((Number(styles.fontSize) * widthMultiplier) /
        2 /
        Math.min(length * 0.06, 6)) *
      canvasScale}px;
      height: ${((Number(styles.fontSize) * heightMultiplier) /
        2 /
        Math.min(length * 0.05, 6)) *
      canvasScale}px;
      background-image: url("${imageUrl && imageUrl !== ""
        ? imageUrl
        : DEFAULT_PRICE_PUBLIC_LOCATION}");
    `;
  }}
`;

const PromoPriceWrapperNameAboveNameBeneathStyles = css`
  align-items: center;
  justify-content: center;
`;

const PromoPriceWrapperPrateleiraPequenoStyles = css`
  flex-direction: row;
  justify-content: center;

  ${({ canvasScale }) => css`
    gap: ${canvasScale * 40}px;
  `}
`;

const PromoPriceWrapperPrateleiraMedioStyles = css`
  flex-direction: column;
`;

export const PromoPriceWrapper = styled.div`
  ${({ styles, length, canvasScale, commonMultiplier }) => css`
    --main-price-width: ${getMainPriceWidth({
      styles,
      length,
      canvasScale,
      commonMultiplier,
    })}px;
  `}
  width: 100%;
  position: relative;
  display: flex;

  ${({ styles, className }) => {
    if (className && className.includes("prateleira-pequeno-price")) {
      return PromoPriceWrapperPrateleiraPequenoStyles;
    }

    return css`
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `;
  }}

  ${({ className }) =>
    className &&
    (className.includes("prateleira-medio-price") ||
      className.includes("prateleira-grande-price")) &&
    PromoPriceWrapperPrateleiraMedioStyles}
`;
